import { useGetSalesTeamListOnMount } from '@user/store/salesTeam'
import {
  useGetAllFunnelStagesOnMount,
  useGetSalesFunnelListOnMount,
} from '@user/store/salesFunnel'
import { useGetSourcesOnMount } from '@user/store/sources'
import { useGetCampaignsOnMount } from '@user/store/campaigns'
import { useGetTargetPestsOnMount } from '@user/store/targetPests'
import { useGetEntityFormSettingsOnMount } from '@user/store/entityFormSettings'
import { ENTITY_TYPES } from '@sales-center/common'
import { useGetCustomFieldsOnMount } from '@user/store/customFields'
import { useGetBranchList } from '@user/store/branches'
import { useGetCustomFieldsSettingsOnMount } from '@user/store/customFieldSettings'
import { useGetSalesTeamPositionsData } from '@user/store/authorization'

export function useData() {
  const campaignsStatus = useGetCampaignsOnMount()
  const customFieldsLoading = useGetCustomFieldsOnMount()
  const leadSourcesStatus = useGetSourcesOnMount()
  const salesFunnelLoadingStatus = useGetSalesFunnelListOnMount()
  const salesFunnelStagesStatus = useGetAllFunnelStagesOnMount()
  const salesTeamLoadingStatus = useGetSalesTeamListOnMount()
  const settingsLoading = useGetEntityFormSettingsOnMount(
    ENTITY_TYPES.Opportunity,
  ).loading
  const targetPestsStatus = useGetTargetPestsOnMount()
  const branchListLoadStatus = useGetBranchList(true)
  const customFieldsSettingsLoading = useGetCustomFieldsSettingsOnMount(
    ENTITY_TYPES.Opportunity,
  ).loading
  const positionsDataStatus = useGetSalesTeamPositionsData()
  return (
    campaignsStatus === 'pending' ||
    customFieldsLoading ||
    leadSourcesStatus === 'pending' ||
    salesFunnelLoadingStatus === 'pending' ||
    salesFunnelStagesStatus === 'pending' ||
    salesTeamLoadingStatus === 'pending' ||
    settingsLoading ||
    targetPestsStatus === 'pending' ||
    branchListLoadStatus === 'pending' ||
    customFieldsSettingsLoading ||
    positionsDataStatus === 'pending'
  )
}
